<jqxInput #inputNumber class="inputNumber" [width]="width" [height]="height" [disabled]="disabled"
  [renderer]="render" [ngModel]="value" (focusout)="valueChanged($event)" [rtl]="true">
</jqxInput>
